import { useSortable } from "@dnd-kit/sortable";

import IconMenu from "../assets/icons/menu-01.svg";
import { Image } from "@chakra-ui/react";

type RowDragHandleCellProps = {
  rowId: string;
  isDisabled?: boolean;
};

const RowDragHandleCell = ({ rowId, isDisabled }: RowDragHandleCellProps) => {
  const { attributes, listeners, isDragging } = useSortable({
    id: rowId,
  });
  return (
    // Alternatively, you could set these attributes on the rows themselves
    <Image
      src={IconMenu}
      {...(isDisabled ? {} : attributes)}
      {...(isDisabled ? {} : listeners)}
      cursor={isDisabled ? "not-allowed" : isDragging ? "grabbing" : "grab"}
      opacity={isDisabled ? 0.4 : 1}
    />
  );
};

export default RowDragHandleCell;
